import Table from '@components/V4/Table/Table';
import { useAuthState } from '@contexts/AuthContext';
import SessionModalSection, {
  ActionButton,
} from '@modules/Admin/components/DetailsModal/DetailsModalSection';
import { CompensationType, UserRole } from '@shared/common';
import { getSymbolFromCurrency, getValueOrNA } from 'apps/agora/src/utils/helpers';
import { useContext, useState } from 'react';
import { MentorDetailsPageContext } from '../../MentorDetailsPage';
import PaymentsForm from './PaymentsForm';

const getCompensationTypeLabel = (compensationType?: CompensationType) => {
  switch (compensationType) {
    case CompensationType.PerSession:
      return 'Per Session';
    case CompensationType.Salaried:
      return 'Salaried';
    default:
      return undefined;
  }
};

const PaymentsTab = () => {
  const { mentor } = useContext(MentorDetailsPageContext);
  const { roles } = useAuthState();
  const canEdit = roles.includes(UserRole.Financial) || roles.includes(UserRole.SuperUser);

  const [isEditingMajor, setIsEditingMajor] = useState(false);

  const buttons: ActionButton[] = canEdit
    ? [{ buttonText: 'Edit', onClick: () => setIsEditingMajor(true) }]
    : [];

  const mentorData = mentor?.mentorData;

  const paymentsInfo = [
    {
      label: 'Compensation Type',
      value: getValueOrNA(getCompensationTypeLabel(mentorData?.compensationType)),
    },
    {
      label: 'Pay Rate',
      value: mentorData?.rate?.amount
        ? `${mentorData?.rate?.amount}${
            getSymbolFromCurrency(mentorData?.rate?.currency ?? '') ?? '$'
          }/hour`
        : undefined,
    },
    {
      label: 'Pay Rate Currency',
      value: getValueOrNA(mentorData?.rate?.currency),
    },
    {
      label: 'Billing Currency',
      value: getValueOrNA(mentorData?.rate?.billingCurrency),
    },
    {
      label: 'VAT Payer',
      value: mentorData?.rate?.vatPayer ? 'Yes' : 'No',
    },
    {
      label: 'Company / Country',
      value: getValueOrNA(mentorData?.company?.country),
    },
    {
      label: 'Company / Freelancer Name',
      value: getValueOrNA(mentorData?.company?.name),
    },
    {
      label: 'Company / Freelancer Address',
      value: getValueOrNA(mentorData?.company?.address),
    },
    {
      label: 'Fiscal registration number (or equivalent)',
      value: getValueOrNA(mentorData?.company?.CUI),
    },
    {
      label: 'IBAN',
      value: getValueOrNA(mentorData?.company?.IBAN),
    },
  ];

  return isEditingMajor && canEdit ? (
    <PaymentsForm
      className="mt-6"
      mentorData={mentorData}
      onCloseEditForm={() => setIsEditingMajor(false)}
      userId={mentor?._id || ''}
    />
  ) : (
    <SessionModalSection className="mt-6" sectionTitle="Payment Details" buttonsArray={buttons}>
      <Table size="small">
        <Table.Body>
          {paymentsInfo.map((info) => (
            <Table.Row key={info.label}>
              <Table.Cell>{info.label}</Table.Cell>
              <Table.Cell>{info.value}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </SessionModalSection>
  );
};

export default PaymentsTab;
